export const INVALID = 'N/A';
export const NODATA = 'NO DATA';
export const PROD_SUBSCRIPTION_NAME = 'FLCIT_DT_FOUNDATION';
export const NON_PROD_SUBSCRIPTION_NAME = 'FLCIT_DT_Foundation_DEV';
